import { FieldValues, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { IAnswerWithValue, IEmpTable, IEmpUser } from '@/models'
import { Checkbox, Screen, Text } from '@/components/ui'
import s from './question-types.module.scss'

interface IEmpTableQuestionProps {
  question: IEmpTable
  register: UseFormRegister<FieldValues>
  setValue: UseFormSetValue<FieldValues>
}

const EmpTableQuestion = ({ question, register, setValue }: IEmpTableQuestionProps) => {
  const usersLength: number = question?.users?.length

  if (!usersLength) {
    return (
      <Text as='p' size='md'>
        Нет сотрудников для оценки. Можете продолжить опрос
      </Text>
    )
  }

  return (
    <>
      <Screen size='lg'>
        <div className={s['question-table']}>
          <table>
            <thead>
              <tr>
                <td aria-label='td' />
                {question.scale.map((scale: IAnswerWithValue) => (
                  <td key={scale.uuid}>{scale.title}</td>
                ))}
              </tr>
            </thead>
            <tbody>
              {question.users.map((user: IEmpUser) => (
                <tr key={user.uuid}>
                  <td>{user.title}</td>
                  {question.scale.map((scale: IAnswerWithValue) => (
                    <td
                      key={scale.uuid}
                      onClick={() => {
                        setValue(`${question.id}.${user.uuid}`, `${scale.uuid}split${scale.value}`)
                      }}
                    >
                      <Checkbox
                        register={register}
                        name={`${question.id}.${user.uuid}`}
                        type='radio'
                        value={`${scale.uuid}split${scale.value}`}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Screen>
      <Screen size='lg' down>
        <table className={s['question-table__mobile']}>
          {question.scale.map((scale: IAnswerWithValue) => (
            <tbody key={scale.uuid} className={s['question-block']}>
              <tr className={s['question-title']}>
                <td>{scale.title}</td>
              </tr>
              {question.users.map((user: IEmpUser) => (
                <tr key={user.uuid}>
                  <td className={s['answer-title']}>{user.title}</td>
                  <td key={scale.uuid}>
                    <Checkbox
                      register={register}
                      name={`${question.id}.${user.uuid}`}
                      type='radio'
                      value={`${scale.uuid}split${scale.value}`}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          ))}
        </table>
      </Screen>
    </>
  )
}

export default EmpTableQuestion
